var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DatastoreDocument, } from '@freelancer/datastore';
import { Feature } from '@freelancer/feature-flags';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { InputSize } from '@freelancer/ui/input';
import { Margin } from '@freelancer/ui/margin';
import { FontType, FontWeight, TextSize } from '@freelancer/ui/text';
import { required } from '@freelancer/ui/validators';
import { MilestoneCancelRequestReasonApi } from 'api-typings/projects/projects';
var MilestoneCancelModalComponent = /** @class */ (function () {
    function MilestoneCancelModalComponent(modalRef, changeDetectorRef) {
        this.modalRef = modalRef;
        this.changeDetectorRef = changeDetectorRef;
        this.ButtonColor = ButtonColor;
        this.TextSize = TextSize;
        this.HeadingType = HeadingType;
        this.InputSize = InputSize;
        this.Margin = Margin;
        this.FontWeight = FontWeight;
        this.Feature = Feature;
        this.FontType = FontType;
        this.reasons = [
            {
                displayText: "The Freelancer didn't meet the deadline",
                value: MilestoneCancelRequestReasonApi.FREELANCER_DID_NOT_MEET_DEADLINE,
            },
            {
                displayText: 'The milestone was created accidentally',
                value: MilestoneCancelRequestReasonApi.ACCIDENTALLY_CREATED,
            },
            {
                displayText: "The Freelancer couldn't complete the task",
                value: MilestoneCancelRequestReasonApi.FREELANCER_DID_NOT_COMPLETE_TASK,
            },
            {
                displayText: 'The milestone is no longer needed',
                value: MilestoneCancelRequestReasonApi.NO_LONGER_NEEDED,
            },
            {
                displayText: 'Other',
                value: MilestoneCancelRequestReasonApi.OTHER,
            },
        ];
        this.selector = new FormControl(this.reasons[0].value, [
            required('Please select a reason'),
        ]);
        this.otherTextControl = new FormControl('', [required('Please provide feedback')]);
    }
    MilestoneCancelModalComponent.prototype.ngOnInit = function () {
        this.selectedOption$ = this.selector.valueChanges;
    };
    MilestoneCancelModalComponent.prototype.cancel = function () {
        var _this = this;
        this.milestoneDoc
            .update(__assign(__assign({}, this.milestone), { action: 'request_cancel', actionReason: this.selector.value, actionReasonText: this.selector.value === 'other' ? this.otherTextControl.value : '', cancellationRequested: true }))
            .then(function (response) {
            console.log('cancel backend response:', response);
            _this.changeDetectorRef.markForCheck();
        });
        this.modalRef.close(false);
    };
    return MilestoneCancelModalComponent;
}());
export { MilestoneCancelModalComponent };
